import {useTranslation} from 'react-i18next';
import MainScreenButton from '../../../../../components/forms/mainScreenButton';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {openPatientForm} from '../../../../../store/reducers/patientContext';
import {ambulanceCodes} from '../../../../../store/reducers/dicts';
import {getConsultantName} from '../../../../../controls/agyle/clinician/clinitianUtils';

const AmbHandoverButton = ({patient, value}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // Selectors
    const ambulance = useSelector(ambulanceCodes);

    return (
        <MainScreenButton
            label={t('Ambulance Handover')}
            filled={value && getConsultantName(value.who) && value.when}
            value={value}
            onOpen={() => dispatch(openPatientForm('ambulanceHandover'))}
            buttonOnly
            buttonOnlyLabel={!(value && value.who && value.when) ? t('Add Ambulance Handover Data') : t('Ambulance Handover')}
            color="primary"
            disabled={!ambulance?.includes(patient?.admission?.arrivalModeCode)}
        />
    );
};

export default AmbHandoverButton;